import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export const betControlStore = Store.createStore({
    /**
     * Current bet value of the slot.
     */
    slot_bet: Store.signal(0),

    /**
     * Formatted version of current bet value.
     */
    slot_betFormatted: Store.signal(''),

    /**
     * List of all available bets to select.
     */
    slot_betList: Store.signal([0]),
});